import { getFormToken } from 'components/molecules/SpamGuard/formToken';
import { FORM_TOKEN_FIELD } from 'components/molecules/SpamGuard/spamGuard.constants';
import { newsletterSubmitHandler } from 'components/organisms/FormsSlice/Forms/NewsletterForm/Newsletter.helper';
import { SalutationEnum } from 'helpers/forms/forms.types';
import { KursanmeldungFormInputTypes } from './KursanmeldungForm.types';

export interface GenericSubmitHandlerProps {
  data: KursanmeldungFormInputTypes;
}
export interface FetchSendFormResponse {
  data: any;
}

export const courseRegistrationSubmitHandler = async ({
  data,
}: GenericSubmitHandlerProps): Promise<any> => {
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...data, [FORM_TOKEN_FIELD]: await getFormToken() }),
  };
  // On success the API also sends the confirmation email itself.
  const response = await fetch('/api/courseRegisterApi', options);
  const registrationData = await response.json();

  if (data.anredeIdCourseRegistration == 1) {
    data.salutation = SalutationEnum.male;
  } else {
    data.salutation = SalutationEnum.female;
  }

  data.firstName = data.Vorname || '';
  data.lastName = data.Nachname || '';

  if (registrationData.successfulRegistration && data.newsletterSubscribe) {
    await newsletterSubmitHandler({ data });
  }

  return registrationData;
};
